import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const SettingsPage = lazy(() =>
  import('@features/settings/components/SettingsPage/SettingsPage').then((module) => ({
    default: module.SettingsPage,
  }))
);

export const Route = createFileRoute('/_auth/settings')({ component: SettingsRouteComponent });

function SettingsRouteComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <SettingsPage />
    </Suspense>
  );
}
